import { createRouter, createWebHistory, type RouteComponent, type RouteRecordRaw } from "vue-router"
import MarriageClaimDetails from "./MarriageClaimDetails"
import MarriageSearchInitializer from "./MarriageClaimSearch"
import NotFound from "./NotFound"

const simpleRoutes: Record<string, RouteComponent> = {
	"/": MarriageSearchInitializer,
	"/Claims/MarriageClaims/:id": MarriageClaimDetails,
	"/:pathMatch(.*)*": NotFound,
}
const routes: RouteRecordRaw[] = [
	...Object.entries(simpleRoutes).map(([path, component]) => ({ path, component, name: component.name })),
]

const router = createRouter({
	routes: [...routes],
	history: createWebHistory(),
})

export default router
